export default __webpack_public_path__ + "static/media/japantrad6.cae5f45c.png";